// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityAnnual {
    'benefitCap'?: string;
    'benefitCapMetAmount'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityAnnual>> = [
        {
            "name":     "benefitCap",
            "baseName": "benefitCap",
            "type":     "string"
        },
        {
            "name":     "benefitCapMetAmount",
            "baseName": "benefitCapMetAmount",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityAnnual.attributeTypeMap;
    }
}
